import sanitize from 'sanitize-filename';

export function sanitizeFileName(fileName: string): string {
    const [ extension ] = fileName.match(/\.[0-9a-z]+$/i) || [ '' ];
    const sanitizedFileName = sanitize(fileName);
    return sanitizedFileName.endsWith(extension)
        ? sanitizedFileName
        : `${sanitizedFileName.substr(0, sanitizedFileName.length - extension.length)}${extension}`;
}
